import { RequestReviewModal } from '@/dashboards/CampaignOptimization/components/RequestReviewModal';
import { SaveCampaignDialog } from '@/dashboards/CampaignOptimization/components/SaveCampaignDialog';
import { SaveAsCampaignDialog } from '@/dashboards/CampaignOptimization/components/SaveCampaignDialog/SaveAsCampaignDialog';
import { useCampaignActions } from '@/dashboards/CampaignOptimization/hooks/useCampaignActions';
import {
    Can,
    FEATURE_FLAG_ACTIONS,
    FEATURE_FLAG_SUBJECTS,
} from '@/features/Casl';
import {
    Button,
    DropdownButton,
} from '@analytical-alley/ui';
import { AiOutlineSave, AiOutlineSend } from 'react-icons/ai';
import { MdOutlineSaveAs } from 'react-icons/md';

export const ActionBar = () => {
    const {
        showSaveCampaignDialog,
        showSaveAsCampaignDialog,
        setShowSaveCampaignDialog,
        setShowSaveAsCampaignDialog,
        saveCampaign,
        saveCampaignAs,
        campaignName,
        canSave,
        showRequestReviewConfirmationDialog,
        setShowRequestReviewConfirmationDialog,
    } = useCampaignActions();

    return (
        <div className="flex">
            <Can
                I={FEATURE_FLAG_ACTIONS.CREATE}
                a={
                    FEATURE_FLAG_SUBJECTS.CAMPAIGN_OPTIMIZATION_DASHBOARD_SAVE_CAMPAIGN_CONFIGURATION
                }
            >
                <div className="flex gap-4 items-center justify-end">
                    {canSave && (
                        <Button
                            size="sm"
                            color="light"
                            tooltip="Request a review from our data scientist to ensure the campaign is optimised for success and get answers to your questions."
                            onClick={() =>
                                setShowRequestReviewConfirmationDialog(true)
                            }
                        >
                            <AiOutlineSend /> Request Review
                        </Button>
                    )}
                    <DropdownButton
                        size="sm"
                        color="glass"
                        disabled={!canSave}
                        onClick={() => setShowSaveCampaignDialog(true)}
                        label="Update"
                        icon={AiOutlineSave}
                        dropdownProps={{
                            placement: 'bottom-end',
                        }}
                        items={[
                            {
                                label: 'Copy As',
                                onClick: () =>
                                    setShowSaveAsCampaignDialog(true),
                                icon: MdOutlineSaveAs,
                            },
                        ]}
                    />
                </div>
            </Can>
            {showSaveCampaignDialog && (
                <SaveCampaignDialog
                    showModal={showSaveCampaignDialog}
                    onClose={() => setShowSaveCampaignDialog(false)}
                    onSave={saveCampaign}
                />
            )}
            {showSaveAsCampaignDialog && (
                <SaveAsCampaignDialog
                    showModal={showSaveAsCampaignDialog}
                    onClose={() => setShowSaveAsCampaignDialog(false)}
                    onSave={saveCampaignAs}
                    defaultName={`${campaignName} (Copy)`}
                />
            )}
            {showRequestReviewConfirmationDialog && <RequestReviewModal />}
        </div>
    );
};
